import {TransactionColKey} from "../../../enums/TransactionColKey";
import {StorageKey} from "../../../enums/StorageKey";
import {withTransactionColumnInfo} from "../../Table/Transaction/withTransactionColumnInfo";
import {transactionColumnSortable} from "../../Table/Transaction/getTransactionColumnSortable";

const columns = [
    { key: TransactionColKey.number },
    { key: TransactionColKey.date },
    { key: TransactionColKey.contact_name },
    { key: TransactionColKey.number2 },
    { key: TransactionColKey.description },
    { key: TransactionColKey.deposit_to },
    { key: TransactionColKey.payment_method },
    { key: TransactionColKey.tag_names },
    { key: TransactionColKey.amount },
    { key: TransactionColKey.status },
    { key: TransactionColKey.custom_fields }, // multi-columns
    { key: TransactionColKey.email },
    { key: TransactionColKey.files },
    { key: TransactionColKey.created_at },
    { key: TransactionColKey.created_by },
    { key: TransactionColKey.action },
];

export default {
    storageKey: StorageKey.bank_income,
    required: [
        TransactionColKey.number,
        TransactionColKey.action,
    ],
    defaulto: [
        TransactionColKey.date,
        TransactionColKey.contact_name,
        TransactionColKey.number2,
        TransactionColKey.amount,
        TransactionColKey.status,
        TransactionColKey.email,
        TransactionColKey.files,
    ],
    sortable: transactionColumnSortable,
    getColumns: (props, fields) => withTransactionColumnInfo(columns, props, fields),
};
